module.exports = __webpack_public_path__ + "static/img/newsDetailPic2.db0e657.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newsDetailPic2.png
// module id = QCQD
// module chunks = 1